<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Programa de Avaliação Médica
    </h1>
</header>
<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<main class="checkup__content" *ngIf="loadingCosts === false else showLoading">
    <ng-template #notCheckUp>
        <h4 class="informacao-no-guides text-center">Você não possui guias disponíveis!</h4>
    </ng-template>
    <div class="checkup__header__imagem pr-xl-5 pl-xl-5">
        <img class="imagem__checkup" src="../../../../../../assets/img/svg/checkup.svg">
        <img class="imagem__checkup" src="../../../../../../assets/img/png/voceNoControleLogo.png">
        <img class="imagem__checkup" src="../../../../../../assets/img/svg/MaisVida.svg">
    </div>
    <div>
        <section class="content-checkup">
            <h3>
                Atenção!
            </h3>
            <p>
                Beneficiários residentes em <b>Londrina e região, Maringá e região</b> não precisam retirar as guias do
                Programa de Avaliação Médica devido ao processo de referenciamento. Nestes municípios, os agendamentos
                serão realizados diretamente pelas <b>APS’s</b>.
            </p>
            <p>
                Para os residentes em <b>Irati, Foz do Iguaçu e Francisco Beltrão</b>, as consultas serão realizadas na
                <b>APS Digital</b>. Por esse motivo, as guias de consulta médica não estarão disponíveis para esses
                locais.
            </p>
            <p>
                <b>Demais beneficiários</b> (residentes em <b>Curitiba</b> e nas demais cidades do Estado, exceto as já
                mencionadas) devem retirar as guias conforme orientado abaixo.
            </p>
            <p>
                O sistema de referenciamento em <b>Irati, Foz do Iguaçu, Francisco Beltrão, Londrina e Maringá</b>,
                considera o cadastro do beneficiário junto à Fundação Copel. Caso tenha encontrado alguma
                inconsistência, entre em contato com a Central de Atendimento pelo telefone: 41 3883-6177 ou
                0800-602-0225
            </p>
            <p>
                <b>Se o nosso sistema não encontrou Guias do Programa de Avaliação Médica para você</b>, entre em
                contato com a Fundação Copel pelo telefone <b>41 3883-6177</b> ou <b>0800-602-0225</b>. Se preferir,
                pode mandar um WhatsApp para <a href="https://wa.me/41991038616"><b>+55 41 99103-8616</b></a>.
            </p>
            <p>
                <b>Lembrando que a Fundação Copel utiliza dos seguintes critérios para liberação das guias do Programa
                    de Avaliação Médica anual de aposentados, cônjuges e pensionistas:</b>
            </p>
            <ul class="content-atention-ul">
                <li>Aposentado(a) pela FUNDAÇÃO COPEL, até 31 de dezembro do ano anterior ao da execução dos exames,
                    inscrito como titular no PROSAÚDE II ou III.</li>
                <li>Cônjuge ou companheiro(a) de Aposentado(a) pela FUNDAÇÃO COPEL até 31 de dezembro do ano anterior ao
                    da execução dos exames, inscrito no PROSAÚDE II ou III.</li>
                <li>Pensionista com inscrição no PROSAÚDE II ou III.</li>
                <li>Homens e mulheres com 40 anos ou mais para Consulta Médica (01 consulta de livre escolha, para
                    todos), Consulta na especialidade de UROLOGIA e exame de PSA para homes com 50 anos ou mais, Exames
                    Laboratoriais, Teste Ergométrico e Consulta Odontológica.</li>
            </ul>
        </section>
        <div class="checkup__card" *ngFor="let beneficiario of beneficiarios;let index = index ">
            <section class="col-xl-11 col-md-12 col-sm-12 px-9 pr-md-9 d-flex">
                <div class="col-xl-7">
                    <span class="checkup__card__title">Beneficiário</span>
                    <p class="checkup__card__content">
                        {{beneficiario.participante}}
                    </p>
                </div>
                <div class="col-xl-4">
                    <span class="checkup__card__title">
                        Período:
                    </span>
                    <p class="checkup__card__content">
                        {{beneficiario.periodo}}
                    </p>
                </div>
                <div class="col-xl-1">
                    <ng-template #showSpinner>
                        <span class="spinner"></span>
                    </ng-template>
                    <button class="btn button-primary" (click)="generatePDF(beneficiario.cpf)">
                        <span>
                            Download
                        </span>
                    </button>
                </div>
            </section>
        </div>
    </div>
</main>